import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/UserGroups",
        name: "UserGroups",
        component: () => import("@/components/users/_UserGroups.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.GetUserGroups,
            breadcrumbs: {
                icon: "user-groups-icon",
                paths: []
            },
            title: "navbar.groups"
        }
    },
    {
        path: "/UserGroups/create",
        name: "CreateUserGroup",
        component: () => import("@/components/users/_UserGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateUserGroup,
            breadcrumbs: {
                icon: "user-groups-icon",
                paths: [
                    ["/UserGroups", i18n.t("userGroups.title")]
                ]
            },
            title: "userGroups.createUserGroup"
        }
    },
    {
        path: "/UserGroups/:groupId/update",
        name: "EditGroup",
        component: () => import("@/components/users/_UserGroupForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateUserGroup,
            breadcrumbs: {
                icon: "user-groups-icon",
                paths: [
                    ["/UserGroups", i18n.t("userGroups.title")]
                ]
            }
        },
        props: true
    }
];
